module.exports = __webpack_public_path__ + "img/bg_figure5.fd656cb6.png";